import { useLayoutEffect } from 'react';
import { notifyInsertionMarkMounted } from 'domains/reporter/RichTextEditor/analytics/insertionPaint';

interface InsertionMarkProbeProps {
  children: React.ReactNode;
  insertionId: string;
}

export const InsertionMarkProbe = ({
  children,
  insertionId,
}: InsertionMarkProbeProps): React.ReactNode => {
  useLayoutEffect(() => {
    notifyInsertionMarkMounted(insertionId);
  }, [insertionId]);

  return children;
};
